import React, { useContext as useContextCore, useEffect } from 'react'
import type { UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import type { Product } from '@ztechapps/common.contract'
import { queries } from '../graphql'
import { useContext } from '../Context'

export type ProviderProps = {
  children: React.ReactNode
}

export type ContextType = {
  listResult: UseListResult<Product>
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const ListViewProvider = ({ children, ...props }: ProviderProps) => {
  const { filter, sort, skip, limit, setProductsCount } = useContext()

  const listResult = useList<Product>({
    ...queries.allConfig,
    filter,
    sort,
    skip: (skip - 1) * limit,
    limit,
    options: {
      dbOptions: {
        collation: null,
      },
    },
  })

  const count = listResult?.pageInfo?.count ?? 0
  useEffect(() => {
    setProductsCount(count)
  }, [count, setProductsCount])

  return <CoreProvider value={{ listResult, ...props }}>{children}</CoreProvider>
}

export const useListViewContext = () => useContextCore(context)
